// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-card {
  width: 100%;
}

app-recommendation-card {
  width: 100%;
}

app-quote-card {
  width: 100%;
}

app-icon.progress-icon {
  margin-right: 10px;
}

ion-spinner.summary-process {
  margin-top: 10px;
  width: 100%;
}

.grid-header {
  font-weight: bold;
}

.summarization-label {
  font-size: 30px;
  margin: auto 5px;
}

.description-label {
  font-size: 20px;
  margin: auto 5px;
}

.description-label-header {
  color: white;
}

ion-accordion {
  margin: 10px auto;
  background-color: white;
}

ion-list.dash-list {
  background-color: var(--content-bg-color);
}
ion-list.dash-list ion-list-header.dark-blue-bg {
  --background: var(--dark-blue-bg);
  --color: white;
}
ion-list.dash-list ion-item.dash-item {
  margin: 10px auto;
}

ion-item[slot=header] {
  --border-width: 0px;
  --inner-border-width: 0px;
}

ion-item.dark-blue-bg {
  --background: var(--dark-blue-bg);
}

@media screen and (max-width: 370px) {
  h1 {
    font-size: 18px;
  }
  ion-title {
    font-size: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/dashboard-user-item-summary/dashboard-user-item-summary.component.scss","webpack://./../../../../../../Program%20Files%20(x86)/Jenkins/workspace/Quadra%20Service%20Call%20Pipeline/QuadraServiceCall/Client/src/app/components/dashboard-user-item-summary/dashboard-user-item-summary.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;ACCJ;;ADEA;EACI,WAAA;ACCJ;;ADCA;EACI,WAAA;ACEJ;;ADCA;EACI,kBAAA;ACEJ;;ADAA;EACI,gBAAA;EACA,WAAA;ACGJ;;ADAA;EACI,iBAAA;ACGJ;;ADAA;EACI,eAAA;EACA,gBAAA;ACGJ;;ADDA;EACI,eAAA;EACA,gBAAA;ACIJ;;ADFA;EACI,YAAA;ACKJ;;ADFA;EACI,iBAAA;EACA,uBAAA;ACKJ;;ADFA;EACI,yCAAA;ACKJ;ADHI;EACI,iCAAA;EACA,cAAA;ACKR;ADFI;EACI,iBAAA;ACIR;;ADAA;EACI,mBAAA;EACA,yBAAA;ACGJ;;ADAA;EACI,iCAAA;ACGJ;;ADAA;EACI;IACI,eAAA;ECGN;EDDE;IACI,eAAA;ECGN;AACF","sourcesContent":["ion-card {\r\n    width: 100%;\r\n}\r\n\r\napp-recommendation-card {\r\n    width: 100%;\r\n}\r\napp-quote-card {\r\n    width: 100%;\r\n}\r\n\r\napp-icon.progress-icon {\r\n    margin-right: 10px;\r\n}\r\nion-spinner.summary-process {\r\n    margin-top: 10px;\r\n    width:100%;\r\n}\r\n\r\n.grid-header {\r\n    font-weight: bold;\r\n}\r\n\r\n.summarization-label {\r\n    font-size: 30px;\r\n    margin: auto 5px;\r\n}\r\n.description-label {\r\n    font-size: 20px;\r\n    margin: auto 5px;\r\n}\r\n.description-label-header {\r\n    color: white;\r\n}\r\n\r\nion-accordion {\r\n    margin: 10px auto;\r\n    background-color: white;\r\n}\r\n\r\nion-list.dash-list {\r\n    background-color: var(--content-bg-color);\r\n\r\n    ion-list-header.dark-blue-bg {\r\n        --background: var(--dark-blue-bg);\r\n        --color: white;\r\n    }\r\n\r\n    ion-item.dash-item {\r\n        margin: 10px auto;\r\n    }\r\n}\r\n\r\nion-item[slot=header] {\r\n    --border-width: 0px;\r\n    --inner-border-width: 0px;\r\n}\r\n\r\nion-item.dark-blue-bg {\r\n    --background: var(--dark-blue-bg);\r\n}\r\n\r\n@media screen and (max-width: 370px) {\r\n    h1 {\r\n        font-size: 18px;\r\n    }\r\n    ion-title {\r\n        font-size: 20px;\r\n    }\r\n}\r\n","ion-card {\n  width: 100%;\n}\n\napp-recommendation-card {\n  width: 100%;\n}\n\napp-quote-card {\n  width: 100%;\n}\n\napp-icon.progress-icon {\n  margin-right: 10px;\n}\n\nion-spinner.summary-process {\n  margin-top: 10px;\n  width: 100%;\n}\n\n.grid-header {\n  font-weight: bold;\n}\n\n.summarization-label {\n  font-size: 30px;\n  margin: auto 5px;\n}\n\n.description-label {\n  font-size: 20px;\n  margin: auto 5px;\n}\n\n.description-label-header {\n  color: white;\n}\n\nion-accordion {\n  margin: 10px auto;\n  background-color: white;\n}\n\nion-list.dash-list {\n  background-color: var(--content-bg-color);\n}\nion-list.dash-list ion-list-header.dark-blue-bg {\n  --background: var(--dark-blue-bg);\n  --color: white;\n}\nion-list.dash-list ion-item.dash-item {\n  margin: 10px auto;\n}\n\nion-item[slot=header] {\n  --border-width: 0px;\n  --inner-border-width: 0px;\n}\n\nion-item.dark-blue-bg {\n  --background: var(--dark-blue-bg);\n}\n\n@media screen and (max-width: 370px) {\n  h1 {\n    font-size: 18px;\n  }\n  ion-title {\n    font-size: 20px;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
